import './PortMainPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Row, Col, Space, Button, Divider } from 'antd'
import PortBottomLayout from '../common/PortBottomLayout'
import {
  getMainThemeProducts,
  getSubThemeProducts,
} from '../../products/ProductProvider'

export default class PortMainPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="PortMainPage">
        {this.getMainThemeProductsLayout()}
        {this.getSubThemeProductsLayout()}

        <Divider
          style={{
            marginTop: 10,
            marginBottom: 0,
            fontFamily: 'MyCustomizedFont',
          }}
        >
          公司介绍
        </Divider>

        <div className="PortCompanyWrapper">
          <div className="PortCompanyInfo">
            <div className="PortCompanyInfoIntroduction">
              {
                '江苏凯士达阀门科技有限公司，是国内一家阀门创新型企业，专注于高端仪表管阀件的研发、生产和销售。公司总部位于江苏省，凭借创新的技术、精湛的工艺和卓越的服务，迅速在国内外细分阀门领域中占据了一席之地。江苏凯士达阀门科技有限公司在危化品运输、半导体行业和氢能领域，拥有独特的市场优势和领先的技术水平，致力于为全球客户提供更高效、更安全、更环保的解决方案。'
              }
            </div>
            <div className="PortCompanyInfoIntroduction">
              {
                '公司产品广泛应用于槽罐车、氢能、半导体、化工、精细化工、医药卫生、食品饮料、酿造、石油储存、油品提炼、电力、冶金、水处理、气体处理、矿业等多个领域，涉及的产品包括但不限于高性能阀门、管件、仪表控制设备及系统。我们的产品在确保密封性、安全性和可靠性的基础上，优化了设计，提升了使用寿命，符合国际领先的质量标准。'
              }
            </div>
          </div>
        </div>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }

  getMainThemeProductsLayout = () => {
    const products = getMainThemeProducts()
    return (
      <div>
        {this.getMainThemeProductGrid(products[0], 3, 'default')}
        {this.getMainThemeProductGrid(products[1], 2, 'primary')}
        {this.getMainThemeProductGrid(products[2], 1, 'default')}
        {this.getMainThemeProductGrid(products[3], 2, 'primary')}
        {this.getMainThemeProductGrid(products[4], 1, 'default')}
      </div>
    )
  }

  getMainThemeProductGrid = (product, index, what) => {
    return (
      <div className={`PortMainThemeProductGrid_${index}`}>
        <div
          className={`PortMainThemeProductGridName_${index}`}
          onClick={() => this.viewProductDetail(product.pid)}
        >
          {product.name}
        </div>
        <div
          className={`PortMainThemeProductGridSlogan_${index}`}
          onClick={() => this.viewProductDetail(product.pid)}
        >
          {product.feature}
        </div>
        <div className={`PortMainThemeProductGridLink_${index}`}>
          <Space size={'large'}>
            <Button
              type={what}
              style={{
                paddingLeft: 40,
                paddingRight: 40,
                paddingTop: 20,
                paddingBottom: 20,
                fontSize: 15,
                fontWeight: '400',
                fontFamily: 'MyCustomizedFont',
              }}
              onClick={() => {
                this.viewContact()
              }}
            >
              咨询购买
            </Button>
            <Button
              ghost
              type={what}
              style={{
                paddingLeft: 40,
                paddingRight: 40,
                paddingTop: 20,
                paddingBottom: 20,
                fontSize: 15,
                fontWeight: '400',
                fontFamily: 'MyCustomizedFont',
              }}
              onClick={() => this.viewProductDetail(product.pid)}
            >
              了解更多
            </Button>
          </Space>
        </div>
        <img
          className={`PortMainThemeProductGridImage_${index}`}
          src={product.picture}
          onClick={() => this.viewProductDetail(product.pid)}
        />
      </div>
    )
  }

  getSubThemeProductsLayout = () => {
    const products = getSubThemeProducts()
    return (
      <div className="PortProductGridWrapper">
        <Row gutter={[{ xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24 }, 20]}>
          {products.map((product) => (
            <Col span={12}>{this.getProductCard(product)}</Col>
          ))}
        </Row>
      </div>
    )
  }

  getProductCard = (product) => {
    return (
      <div
        className="PortProductGrid"
        onClick={() => this.viewProductDetail(product.pid)}
      >
        <img className="PortProductGridImage" src={product.picture} />
        <div className="PortProductGridName">{product.name}</div>
        <div className="PortProductGridLink">
          <Space size={'large'}>
            {product.purchasable
              ? this.getCommonLinkButton(product)
              : this.getCommonConsultButton()}
            <Button
              type="default"
              size="small"
              style={{
                fontSize: 14,
                fontWeight: '400',
                fontFamily: 'MyCustomizedFont',
                fontFamily: 'MyCustomizedFont',
              }}
              onClick={() => this.viewProductDetail(product.pid)}
            >
              了解更多
            </Button>
          </Space>
        </div>
      </div>
    )
  }

  getCommonLinkButton = (product) => {
    return (
      <Button
        type="primary"
        size="small"
        style={{
          fontSize: 14,
          fontWeight: '400',
          fontFamily: 'MyCustomizedFont',
          fontFamily: 'MyCustomizedFont',
        }}
        onClick={() => {
          this.gotoShop(product)
        }}
      >
        立即购买
      </Button>
    )
  }

  getCommonConsultButton = () => {
    return (
      <Button
        color="pink"
        variant="filled"
        size="small"
        style={{
          fontSize: 14,
          fontWeight: '400',
          fontFamily: 'MyCustomizedFont',
        }}
        onClick={(e) => {
          e.stopPropagation()
          this.viewContact()
        }}
      >
        咨询购买
      </Button>
    )
  }

  viewProductDetail = (pid) => {
    this.props.history.push('/product?pid=' + pid)
  }

  viewContact = () => {
    this.props.history.push('/contact')
  }

  gotoShop = (product) => {
    window.open(product.link, '_blank')
  }
}
